export { READINESS_COLORS as QUESTION_COLORS } from "../../../../constants";

export const SCORE_COLOR = "var(--tracking)";
export const BAND_COLOR = "rgba(91, 197, 0, 0.16)";
export const BELOW_COLOR = "var(--energy)";
export const ABOVE_COLOR = "var(--gradient-right)";
export const MUTED_COLOR = "var(--white-50)";
export const OVERLAY_COLORS = {
  sessionRpe: "var(--rr-overlay-rpe)",
  hrv: "var(--rr-overlay-hrv)",
  restingHr: "var(--rr-overlay-hr)",
};
